/** @param {unknown} data */
export function parseRemoteVersion(data) {
  if (!data || typeof data !== 'object') return { buildId: null, builtAt: null }
  const record = /** @type {{ buildId?: unknown, builtAt?: unknown }} */ (data)
  return {
    buildId: String(record.buildId ?? '').trim() || null,
    builtAt: String(record.builtAt ?? '').trim() || null,
  }
}

/** Stable key for dismiss state for a remote version payload. */
export function remoteUpdateKey(remote) {
  if (!remote) return null
  return remote.buildId && remote.buildId !== 'dev'
    ? remote.buildId
    : remote.builtAt || remote.buildId || null
}
